<script>
export default {
  name: 'AppCheckbox',
  props: { value: Boolean, size: [String, Number], radio: Boolean },
  methods: {
    checkChanged($event) {
      let target = $event.target;
      if (this.isRadio) {
        target.checked = true;
      }
      this.$emit('input', target.checked);
    }
  }
};
</script>

<template>
  <label class="app-checkbox">
    <input type="checkbox" :checked="value" @change="checkChanged" />
    <span v-if="radio" class="icon-container radio">
      <div v-if="value" class="radio-fill icon"></div>
      <ion-icon name="radio-button-off" class="radio-outline" />
    </span>
    <span v-else class="icon-container icon" :style="{ width: size + 'px', height: size + 'px' }">
      <ion-icon :style="{ 'font-size': size + 'px' }" name="checkbox" class="icon checkbox" />
      <ion-icon :style="{ 'font-size': size + 'px' }" name="square-outline" class="icon square-outline" />
    </span>
    <span class="slot-label">
      <slot></slot>
    </span>
  </label>
</template>

<style lang="scss" scoped>
.app-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;

  input {
    display: none;
  }

  .icon-container {
    margin-right: 6px;
  }

  .radio {
    height: 18px;
    display: flex;
    align-items: center;
    position: relative;

    .radio-outline {
      font-size: 18px;
      visibility: visible;
      color: var(--purple-light-3);
      transition: 0.15s ease-out;

      &:hover {
        color: var(--primary-color);
      }
    }

    .radio-fill {
      position: absolute;
      left: 4px;
      top: 4px;
      transition: opacity 0.2s, color 0.2s;
      height: 10px;
      width: 10px;
      background: var(--primary-color-gradient);
      border-radius: 50%;

      & + .radio-outline {
        color: var(--purple-color);
      }
    }
  }

  &:hover .icon ion-icon.square-outline {
    color: var(--primary-color);
  }

  .icon {
    position: relative;
    width: 17px;
    height: 17px;

    .icon {
      position: absolute;
      left: 0;
      top: 0;
      transition: opacity 0.2s, color 0.2s;
      font-size: 17px;

      &.square-outline {
        color: var(--purple-light-3);
        opacity: 1;

        &:hover {
          color: var(--primary-color);
        }
      }

      &.checkbox {
        color: var(--primary-color);
        opacity: 0;
      }
    }
  }

  .slot-label {
    // line-height: 19px;
    font-size: 13px;
    color: var(--primary-color);
  }

  input:checked + .icon {
    .icon {
      &.square-outline {
        opacity: 0;
      }

      &.checkbox {
        opacity: 1;
      }
    }
  }
}
</style>
